export default __webpack_public_path__ + "static/media/pere-noel-light.77fb4861.png";